<div
  class="violations"
  [ngClass]="{ 'closed': closedPanel }"
  *ngIf="violations.length > 0; else noData">
  <div
    class="violation"
    *ngFor="let violation of violations"
    [ngClass]="{ 'active': lastData.passId === violation.passId }"
    [style]="{ 'border-color': getRegulationColor(violation?.regulationId) + '!important' }"
    (click)="selectViolation(violation)">
    <p
      class="laneCode"
      [style]="{ 'background-color': getRegulationColor(violation?.regulationId) + '!important' }">{{
      violation?.laneCode }}</p>
    <div *ngIf="violation?.files[0]?.type === 'video'">
      <video
        crossorigin="anonymous"
        [src]="violation?.files[0]?.urlCurrent"
        type="video/mp4" autoplay loop playsinline muted
        oncontextmenu="return false;">
      </video>
    </div>
    <div *ngIf="violation?.files[0].type !== 'video'">
      <img [src]="violation?.files[0]?.urlCurrent" crossorigin="*" />
    </div>
  </div>
</div>
<ng-template #noData>
  <p class="text-center"><em>Aguardando recebimento de dados...</em></p>
</ng-template>
